<template>
    <section class="table">
        <div class="box">
            <div class="table__header">
                <h1>{{title}}</h1>
                <div class="btns">
                    <router-link v-if="hasPermission('Roles', 'insert')" class="btn" :to="{ name: 'roleForm', params: { action: 'create' } }">
                        <i class="fal fa-plus-circle"></i>
                    </router-link>
                </div>

            </div>

            <div class="table__content">


                <div class="searchInput">
                    <div class="searchInput__inner">
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                label="Cerca"
                                single-line
                                hide-details
                        ></v-text-field>
                    </div>
                </div>


                <v-data-table
                        :headers="headers"
                        :items="roles"
                        :search="search"
                        class="elementTable"
                        :rows-per-page-items="rowsPerPageItems"
                        :pagination.sync="pagination"
                >
                    <template v-slot:items="props">
                        <td>{{props.item.role}}</td>
                        <td class="action"  v-if="canEditOrDelete">
                            <div class="actions">
                                <router-link class="button icon" v-if="hasPermission('Roles', 'edit')" :to="{ name: 'roleForm', params: { id: props.item.id, action: 'edit' } }">
                                    <i class="fal fa-edit"></i>
                                </router-link>

                                <a v-if="hasPermission('Roles', 'delete') && props.item.id>4" class="button icon" @click.stop="nameSelected = props.item.role; idSelected = props.item.id; dialog = true">
                                    <i class="fal fa-trash-alt"></i>
                                </a>
                            </div>
                        </td>
                    </template>
                </v-data-table>
            </div>
        </div>

        <!-- MODALE LIBRARYFORM -->
        <div v-if="dialog" class="modal-overlay" @click.self="dialog = false">
            <div class="modal modal-confirm">

                <!-- HEADER -->
                <div class="modal-header">
                    <span class="headline">Sei sicuro?</span>
                    <button class="close-btn" @click="dialog = false">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
                <!-- BODY -->
                <div class="modal-body">
                    <div style="margin-bottom: 20px">L'elemento <strong>{{ nameSelected }}</strong> verrà eliminato e non potrà essere ripristinato</div>
                    <div class="flex-gap">
                        <button class="button button-p" @click="idSelected = null; dialog = false">Annulla</button>
                        <button class="button button-p" @click="deleteProject(idSelected); dialog = false">Ok cancella</button>
                    </div>
                </div>
            </div>
        </div>


    </section>
</template>
<script>

    import { mapGetters } from 'vuex'

    export default {
        name: 'listRoles',
        
        data () {
            return {
                title: 'Ruoli',
                dialog: false,
                idSelected: null,
                nameSelected: null,
                search: '',
                rowsPerPageItems: [20, 40, 60, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
                pagination: {
                    rowsPerPage: 20
                },
                headers: [
                    { text: 'Nome', align: 'left', value: 'role' },
                    { text: '', sortable: false }
                ]
            }
        },
        computed: {
            ...mapGetters('rolesModule', ['roles']),
            ...mapGetters(['hasPermission']),
            canEditOrDelete() {
                return this.hasPermission('Roles', 'edit') || this.hasPermission('Roles', 'delete');
            },
        },

        methods: {
            loadScriptTypes () {
                this.$store.dispatch('rolesModule/loadRoles', {urlToConnect: 'roles'})
            },
            deleteRole(id){
                var parameters = {
                    urlToConnect: 'roles/' + id,
                    methodToConnect: 'delete',
                    _method: "delete"
                }
                this.idSelected = null;
                this.nameSelected = null;
                this.$store.dispatch('rolesModule/deleteRole', parameters)
            }
        },
        watch: {
            '$route' () {
                this.loadScriptTypes()
            }
        },
        created () {
            this.loadScriptTypes()
            this.$store.dispatch('rolesModule/resetRole')
        }


    }
</script>